export * from './types'
export * from './tokens'
export * from './submit'
export * from './registry'

// Register built-in resolvers as a side effect. Order matters: this is
// the order kinds are shown in the picker when a search hits multiple
// kinds, with campaign first (most-common pick) then video, then brand.
import { mentionRegistry } from './registry'
import { campaignResolver } from './resolvers/campaign'
import { videoResolver } from './resolvers/video'
import { brandResolver } from './resolvers/brand'

mentionRegistry.register('campaign', campaignResolver)
mentionRegistry.register('video', videoResolver)
mentionRegistry.register('brand', brandResolver)
